export default __webpack_public_path__ + "static/media/fNeutral14.33d4ab6f.png";